import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";

/**
 * Component that blocks staging environment from being indexed
 * Production pages are controlled by per-page Helmet tags and robots.txt
 */
export const SEOProtection: React.FC = () => {
  const [isStaging, setIsStaging] = useState(false);
  
  useEffect(() => {
    // Detect if we're on staging environment
    if (typeof window !== "undefined") {
      setIsStaging(window.location.hostname.includes("store-staging.wecarrybags.co.uk"));
    }
  }, []);
  
  // Only block staging from being indexed
  if (isStaging) {
    return (
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
    );
  }

  return null;
};

